import React from 'react';
import './TopSadzbyBanner.css';

const kratkyFix = (z) => {
  if (z && typeof z.fixaciaRoky === 'number' && z.fixaciaRoky > 0) return `${z.fixaciaRoky}R FIX`;
  if (z && typeof z.fixaciaMesiace === 'number' && z.fixaciaMesiace > 0) return `${z.fixaciaMesiace}M FIX`;
  return 'FIX';
};

export default function TopSadzbyBanner({ topSadzby }) {
  const zoradene = (topSadzby || [])
    .filter((z) => z && typeof z.urok !== 'undefined')
    .slice()
    .sort((a, b) => {
      const ua = Number(a.urok || 0);
      const ub = Number(b.urok || 0);
      if (ua !== ub) return ua - ub;
      // sekundárne: preferuj roky pred mesiacmi a nižšiu fixáciu
      const fa = Number(a.fixaciaRoky || 0) * 12 + Number(a.fixaciaMesiace || 0);
      const fb = Number(b.fixaciaRoky || 0) * 12 + Number(b.fixaciaMesiace || 0);
      return fa - fb;
    });

  return (
    <div className="top-banner">
      <div className="top-banner__text">
        <span className="top-banner__label">TOP SADZBY:</span>

        <div className="top-banner__list" aria-label="Top sadzby">
          {zoradene.map((z, idx) => {
            const urok = Number(z.urok || 0).toFixed(2).replace('.', ',');
            const fix = kratkyFix(z);

            const kod = z.bankaKod ? String(z.bankaKod) : '';
            const text = `${kod} ${urok}% p.a. (${fix})`.trim();

            return (
              <span key={`${urok}-${fix}-${idx}`} className="top-banner__item">
                {idx > 0 ? <span className="top-banner__sep"> | </span> : null}
                {text}
              </span>
            );
          })}
        </div>
      </div>

      <a className="top-banner__link" href="/sadzby">
        Detail úrokov
      </a>
    </div>
  );
}